const initialState = {
  dates: [],
  shops: [],
  shop_category: [],
  shelf_insights: [],
  loader: false,
  toggle_loader: {
    dates: null,
    shops: null,
    shop_category: null,
    shelf_insights: null,
  },
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SET_CAPTURE_DATES":
      return {
        ...state,
        dates: payload,
        shops: "",
        shop_category: "",
        shelf_insights: "",
      };

    case "SET_SHOPS":
      return {
        ...state,
        shops: payload,
        shop_category: "",
        shelf_insights: "",
      };

    case "SET_SHOP_CATEGORY_DATA":
      return {
        ...state,
        shop_category: payload,
        shelf_insights: "",
      };

    case "SET_SHELF_INSIGHTS_DATA":
      return {
        ...state,
        shelf_insights: payload,
      };

    case "TOGGLE_LAODER":
      return {
        ...state,
        loader: payload,
      };

    case "CLEAR_REDUCER_DATA":
      return {
        ...state,
        dates: [],
        shops: [],
        shop_category: [],
        shelf_insights: [],
      };

    case "TOGGLE_INSIGHTS_DATE_LOADER":
      //   if (payload) {
      return {
        ...state,
        toggle_loader: {
          ...state.toggle_loader,
          dates: payload,
          shops: null,
        },
      };
    //   }

    case "TOGGLE_INSIGHTS_SHOP_LOADER":
      return {
        ...state,
        toggle_loader: {
          ...state.toggle_loader,
          shops: payload,
          shop_category: null,
          shelf_insights: null,
        },
      };

    case "TOGGLE_INSIGHTS_SHOP_CATEGORY_LOADER":
      return {
        ...state,
        toggle_loader: {
          ...state.toggle_loader,
          shop_category: payload,
          shelf_insights: null,
        },
      };

    case "TOGGLE_INSIGHTS_SHELF_INSIGHTS_LOADER":
      return {
        ...state,
        toggle_loader: {
          ...state.toggle_loader,
          shelf_insights: payload,
        },
      };

    default:
      return {
        ...state,
      };
  }
};
